module.exports = __webpack_public_path__ + "static/media/VIAL-LAFISE-01.02d24b1d.svg";